import React from 'react';
import { useUI } from '../../context/UIContext';

const Navigation = () => {
  const { activeSection, mobileMenuOpen, closeMobileMenu } = useUI();

  const navLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'services', label: 'Services' },
    { id: 'qualifications', label: 'Qualifications' },
    { id: 'projects', label: 'Projects' },
    { id: 'reviews', label: 'Reviews' },
    { id: 'service-area', label: 'Service Area' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <nav className={`main-navigation ${mobileMenuOpen ? 'mobile-open' : ''}`}>
      <ul className="nav-list">
        {navLinks.map((link) => (
          <li key={link.id} className={activeSection === link.id ? 'active' : ''}>
            <a 
              href={`#${link.id}`} 
              onClick={closeMobileMenu}
              aria-current={activeSection === link.id ? 'page' : undefined}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
